export default __webpack_public_path__ + "static/media/stayInTheLoopPic.9b031015.svg";